import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../api/axiosInstance';
import { useModal } from '../../contexts/ModalContext';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [setBreadcrumb, setBreadcrumbLink] = useOutletContext();
  const [proceeding, setProceeding] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');

  const { openModal } = useModal();

  useEffect(() => {
    setBreadcrumb(['Profile', 'Change Password']);
    setBreadcrumbLink(['/dashboard/settings', '/dashboard/settings/changepassword']);
  }, [setBreadcrumb, setBreadcrumbLink]);

  const changePassword = async () => {
    try {
      if (password !== '' || currentPassword !== '') {
        if (currentPassword !== password) {
          if (confirmPassword === password) {
            setProceeding(true);
            let res = await api.post(`/auth/change-password`,
              {
                oldPassword: currentPassword,
                newPassword: password,
              }
            );
            if (!res.data.error) {
              setPassword('');
              setConfirmPassword('');
              setCurrentPassword('');
              openModal('success', res.data.message);
              setProceeding(false);
              navigate('/Marketing/profile');
            } else {
              openModal('failure', res.data.message);
              setProceeding(false);
            }
          } else {
            openModal('failure', `New Password and Confirm password do not match`);
          }
        } else {
          openModal('failure', `Current Password and New password cannot be same.`);
        }
      } else {
        openModal('failure', `Password cannot be empty.`);
      }
    } catch (error) {
      if (error.message === "Network Error") {
        openModal('failure', 'No Internet Connection');
      } else {
        openModal('failure', error.message);
      }
    }
  };

  const handelChangePassword = (event) => {
    event.preventDefault();

    changePassword();
  };

  return (
    <>
      <div className='p-4'>
        <div className="p-4 mb-4 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <h3 className="mb-4 text-xl font-semibold dark:text-white">Change Password</h3>
          <form method='post' onSubmit={handelChangePassword}>
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-6 sm:col-span-3">
                <label for="current-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Current password</label>
                <input onChange={(e) => setCurrentPassword(e.target.value)} value={currentPassword} type="password" name="current-password" id="current-password" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500" placeholder="••••••••" required />
              </div>
              <div className="col-span-6 sm:col-span-3">
                <label for="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">New password</label>
                <input onChange={(e) => setPassword(e.target.value)} value={password} type="password" id="password" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="••••••••" required />

              </div>
              <div className="col-span-6 sm:col-span-3">
                <label for="confirm-password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm password</label>
                <input autoComplete="off" onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} type="password" name="confirm-password" id="confirm-password" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500" placeholder="••••••••" required />
              </div>
              <div className="col-span-6 sm:col-full">
                <button className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800" type="submit">
                  {proceeding ? (<>
                    <div className='inline mr-3' role="status">
                      <svg aria-hidden="true" className="w-5 h-5 inline text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  </>) : (<></>)}Change Password</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
};

export default ChangePassword;
